<div class="overlay flex flex-column align-items-center justify-content-center" *ngIf="isLoading">
    <label class="text-white mb-5" *ngIf="label" >{{label}}</label>
    <i class="pi pi-spinner loading-icon" style="color: white;"> </i>
</div>
